import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { MapOptions } from '../../../core/types/types';
import { defaultMapOptions } from '../../../components/Map/base/configs/options';

export interface MapOptionsState {
    value: MapOptions;
}

const initialState: MapOptionsState = {
    value: defaultMapOptions,
};

export const mapOptionsSlice = createSlice({
    name: 'mapOptionsStateSetter',
    initialState,
    reducers: {
        setMapOptionsState: (state, action: PayloadAction<MapOptions>) => {
            state.value = action.payload;
        },
    },
});

export const { setMapOptionsState } = mapOptionsSlice.actions;
export default mapOptionsSlice.reducer;
